const TYPES = {
  IAnatomyOrientationController: Symbol.for('IAnatomyOrientationController')
};

export { TYPES };
